import iconPen from "../../../assets/grammar/fill_icon.png";

export function replaceTags(text) {
  // 替换<y></y>
  let result = text.replace(/<y>(.*?)<\/y>/g, '<span class="highlight-yellow">$1</span>');

  // 替换<bl></bl>
  result = result.replace(/<bl>(.*?)<\/bl>/g, '<span class="highlight-blue">$1</span>');

  // 替换<g></g>
  result = result.replace(/<g>(.*?)<\/g>/g, '<span class="highlight-green">$1</span>');

  // 替换<r></r>
  result = result.replace(/<r>(.*?)<\/r>/g, '<span class="highlight-red">$1</span>');

  // 替换<d></d>
  result = result.replace(
    /<d>(.*?)<\/d>/g,
    '<span class="underline tag-d"><label class="hide-underline-item">$1</label></span>'
  );

  return result;
}

export function insetIconPen(classname) {
  const dom = document.querySelectorAll(classname);
  dom.forEach((item) => {
    if(item.querySelector('.icon-pen')){
      item.removeChild(item.querySelector('.icon-pen'));
    }
    const tag_d = item.querySelectorAll(`.tag-d`);
    tag_d.forEach((t) => {
      const iconDom = document.createElement("img");
      iconDom.src = iconPen;
      iconDom.className = "icon-pen";
      t.insertAdjacentElement("afterend", iconDom);
      iconDom.onclick = function (e) {
        const previousSibling = e.target.previousSibling;
        const childs = previousSibling.childNodes;
        childs.forEach((child) => {
          if (child.classList.contains("hide-underline-item")) {
            child.classList.remove("hide-underline-item");
          } else {
            child.classList.add("hide-underline-item");
          }
        });
      };
    });
  });
}
